// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"store-breadcrumb__breadcrumbs__jO6yC"};